/* eslint-disable import/no-cycle */
import Vue from 'vue';
import VueRouter from 'vue-router';

// import all route module
import broadcastRoute from './broadcast';
import clientRoute from './client';
import daftarTugasRoute from './daftarTugas';
import dasboardDetailRoute from './dashboardDetail';
import dasboardProfilingRoute from './dashboardProfiling';
import feeManagementRoute from './feeManagement';
import fileSettlementRoute from './fileSettlement';
import forceActiveManagementRoute from './forceActiveManagement';
import inputerRoute from './inputer';
import inputerReportRoute from './inputerReport';
import inputerTrackingPengajuanRoute from './inputerTrackingPengajuan';
import insertTransactionRoute from './insertTransaction';
import insertTransactionOnUsRoute from './insertTransactionOnUs';
import maintenanceSettlementRoute from './maintenanceSettlement';
import masterRoute from './master';
import merchantManagementRoute from './merchantManagement';
import merchantTools from './merchantTools';
import midRoute from './mid';
import monitoringMerchant from './monitoringMerchant';
import passwordChange from './passwordChange';
import promoRoute from './promo';
import rbacRoute from './rbac';
import reconciliationRoute from './reconciliation';
import refundInternalRoute from './refundInternal';
import reportRoute from './report';
import reportBpjstkRoute from './reportBpjstk';
import reportCpmRoute from './reportCpm';
import reportEdcRoute from './reportEdc';
import reportPromoRoute from './reportPromo';
import reportSettlementBni from './reportSettlementBni';
import reportWalletTransactionRoute from './reportWalletTransaction';
import resendEmailRoute from './resendEmail';
import settingFeeRoute from './settingFee';
import settlementSettingRoute from './settlementSetting';
import trackingPengajuanRoute from './trackingPengajuan';
import userRoute from './user';
import userMerchantManagementRoute from './userMerchantManagement';
import ChangePassword from '../components/ChangePassword.vue';
import ChangeEmail from '../components/ChangeEmail.vue';
import SetPassword from '../components/SetPassword.vue';
import ReactiveDormant from '../components/ReactiveDormant.vue';
import ChangePicRoute from './changePic';
import systemLogRoute from './systemLog';
import ForgotPassword from '../components/ForgotPassword.vue';
import Login from '../components/Login.vue';
import store from '../store/index';
import { dataAppTitle } from '../store/params';

import Dashboard from '../views/Dashboard.vue';

import NotFound from '../views/NotFound.vue';
import Parent from '../views/Parent.vue';
import Profile from '../views/Profile.vue';
import loginOtp from './loginOtp';
import callbackManagementRoute from './merchantCallbackManagement';
import masterDataRoute from './masterData';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

Vue.use(VueRouter);

export const setBreadcrumb = (text = '', link = '', disabled = false) => ({
  text,
  disabled,
  to: link,
  link: true,
  exact: true,
});

const routes = [
  {
    path: '/',
    meta: {
      title: 'BNI QRIS - Dashboard',
      appBarTitle: 'Dashboard',
    },
    component: Parent,
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: {
          title: 'BNI QRIS - Dashboard',
          appBarTitle: 'Dashboard',
        },
        component: Dashboard,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: 'BNI QRIS - Login',
      appBarTitle: 'Login',
    },
    component: Login,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    meta: {
      title: 'BNI QRIS - Forgot Password',
      appBarTitle: 'Forgot Password',
    },
    component: ForgotPassword,
  },
  {
    path: '/validate-forgot-password/:accessKey/activate/:idEncrypted',
    name: 'ValidateForgotPassword',
    meta: {
      title: 'BNI QRIS - Validate Forgot Password',
      appBarTitle: 'Validate Forgot Password',
    },
    component: ForgotPassword,
  },
  {
    path: '/change-email/:token',
    name: 'ChangeEmail',
    meta: {
      title: 'BNI QRIS - Ubah Email',
      appBarTitle: 'Ubah Email',
    },
    component: ChangeEmail,
  },
  {
    path: '/set-password/:token',
    name: 'SetPassword',
    meta: {
      title: 'BNI QRIS - Input Password',
      appBarTitle: 'Input Password',
    },
    component: SetPassword,
  },
  {
    path: '/dormant-reactivated/:token',
    name: 'ReactiveDormant',
    meta: {
      title: 'BNI QRIS - Reactivate Account',
      appBarTitle: 'Reactivate Account',
    },
    component: ReactiveDormant,
  },
  loginOtp,
  userRoute,
  clientRoute,
  ChangePicRoute,
  daftarTugasRoute,
  inputerRoute,
  reconciliationRoute,
  trackingPengajuanRoute,
  inputerTrackingPengajuanRoute,
  masterRoute,
  settingFeeRoute,
  feeManagementRoute,
  reportRoute,
  inputerReportRoute,
  rbacRoute,
  broadcastRoute,
  resendEmailRoute,
  merchantManagementRoute,
  maintenanceSettlementRoute,
  refundInternalRoute,
  reportEdcRoute,
  settlementSettingRoute,
  insertTransactionRoute,
  insertTransactionOnUsRoute,
  reportWalletTransactionRoute,
  dasboardDetailRoute,
  dasboardProfilingRoute,
  fileSettlementRoute,
  monitoringMerchant,
  passwordChange,
  reportSettlementBni,
  reportBpjstkRoute,
  promoRoute,
  reportPromoRoute,
  userMerchantManagementRoute,
  forceActiveManagementRoute,
  reportCpmRoute,
  merchantTools,
  callbackManagementRoute,
  midRoute,
  systemLogRoute,
  masterDataRoute,
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      title: 'BNI QRIS - User Profile',
      appBarTitle: 'User Profile',
    },
    component: Profile,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash]) for this route
    // which is lazy-loaded when the route is visited.
    meta: {
      title: 'BNI QRIS - About',
      appBarTitle: 'About',
    },
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    meta: {
      title: 'BNI QRIS - Change Password',
      appBarTitle: 'Change Password',
    },
    component: ChangePassword,
  },
  {
    path: '*',
    meta: {
      title: 'BNI QRIS',
      appBarTitle: '',
    },
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const publicRoutes = ['LoginOTP', 'Login', 'ForgotPassword', 'ValidateForgotPassword', 'ChangeEmail', 'SetPassword', 'ReactiveDormant'];
  if (!publicRoutes.includes(to.name)) {
    store.dispatch('checkAuth', {
      data: localStorage.getItem('logged_in_qram'),
      key: localStorage.getItem('qram_key'),
    });
  }
  next();
});

const DEFAULT_TITLE = dataAppTitle == null ? 'BNI QRIS' : dataAppTitle;

router.afterEach((to) => {
  Vue.nextTick(() => {
    store.commit('setBreadcrumbs', {
      data:
        to.meta.breadcrumbs !== undefined ? to.meta.breadcrumbs(to.params) : [],
      // data: []
    });
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
